import { PayloadAction } from '@reduxjs/toolkit';

import { IToastWrapper } from '../../core/components/toasts/IToastWrapper';

export const ToastReducer = {
	toggleToast: (state: IToastWrapper, action: PayloadAction<IToastWrapper>) => {
		state.status = action.payload.status;
		state.open = action.payload.open;
		state.text = action.payload.text;
		state.isCLoseIcon = action.payload.isCLoseIcon;
		state.autoClose = action.payload.autoClose;
		state.closeTimeout = action.payload.closeTimeout;
		state.callBackInfo = action.payload.callBackInfo;
	},
};
